import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImgComponent } from '../img/img.component';
import {
  DsButtonComponent,
  DsTooltipComponent,
  DsTooltipDirective,
} from '@assecods/ng-design-system';
import { IconComponent } from '../icon/icon.component';
import { FS_EXTERNAL_LINKS } from '../../../../config/external-links/fs-external-links';

@Component({
  selector: 'idh-top-bar-info',
  templateUrl: 'top-bar-info.component.html',
  styleUrls: ['top-bar-info.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    ImgComponent,
    DsButtonComponent,
    DsTooltipDirective,
    DsTooltipComponent,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBarInfoComponent {
  protected readonly links = FS_EXTERNAL_LINKS;
  key = input.required<string>();
  public openLink(href: string) {
    window.open(href, '_blank');
  }
}
